var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRectangleInfoOutline20 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1 2H6.9c-1.145 0-1.913.001-2.505.05-.574.046-.849.13-1.03.222a2.5 2.5 0 0 0-1.093 1.093c-.092.181-.176.456-.222 1.03C2 4.987 2 5.755 2 6.9v4.2c0 1.145.001 1.913.05 2.505.046.574.13.849.222 1.03a2.5 2.5 0 0 0 1.093 1.092c.181.093.456.177 1.03.223.592.049 1.36.05 2.505.05h2.2c1.145 0 1.913-.001 2.505-.05.574-.046.849-.13 1.03-.223a2.5 2.5 0 0 0 1.092-1.092c.093-.181.177-.456.223-1.03.049-.592.05-1.36.05-2.505V6.9c0-1.145-.001-1.913-.05-2.505-.046-.574-.13-.849-.223-1.03a2.5 2.5 0 0 0-1.092-1.093c-.181-.092-.456-.176-1.03-.222C11.013 2 10.245 2 9.1 2Zm-8.164.684C.5 3.54.5 4.66.5 6.9v4.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h2.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748c.436-.856.436-1.976.436-4.216V6.9c0-2.24 0-3.36-.436-4.216A4 4 0 0 0 13.316.936C12.46.5 11.34.5 9.1.5H6.9C4.66.5 3.54.5 2.684.936A4 4 0 0 0 .936 2.684Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM4 10.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM4 13.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgRectangleInfoOutline20;